import script from "./LensDetailsContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LensDetailsContent.vue?vue&type=script&setup=true&lang=js"

import "./LensDetailsContent.vue?vue&type=style&index=0&id=466ae299&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466ae299"]])

export default __exports__